// test2565
(2565 && 0);
